import React from "react";
import { PeekBox, PeekButton, PeekTooltip } from "@piiqtechnologies/ui-components";
export const HEADER_BUTTON_SIZE = "40px";
export const HeaderIconButton = ({ label, icon, onClick, tooltip, disabled = false, filled = false, testId, }) => {
    return (React.createElement(PeekTooltip, { title: tooltip, placement: "top" },
        React.createElement(PeekBox, null,
            React.createElement(PeekButton, { "data-testid": testId, "aria-label": label, disabled: disabled, onClick: onClick, variant: filled ? "contained" : "outlined", color: filled ? "primary" : "info", sx: {
                    height: HEADER_BUTTON_SIZE,
                    width: HEADER_BUTTON_SIZE,
                    minWidth: HEADER_BUTTON_SIZE,
                } }, icon))));
};
export default HeaderIconButton;
